<router-outlet *ngIf="!(isMobile$ | async)"></router-outlet>

<div *ngIf="isMobile$ | async" class="mobile-not-supported centered">
  <img class="word-mark" src="/assets/logo/dark/logo-stroke.svg" alt="" />
  <div class="text-404">To access BudSense, please sign-in from a desktop, laptop or tablet device.</div>
</div>
